import { Link as ChakraLink, useToken } from '@chakra-ui/react';

import type { NavChild } from './useSideNavigation';
import { Link as RouterLink } from 'react-router-dom';
import { hexToRGBA } from '@/client/utils/hexToRGBA';

interface ChildLinkProps {
  navLink: NavChild;
}

export default function ChildLink({ navLink }: ChildLinkProps) {
  const [brandColor] = useToken('colors', ['brand.primary']);

  const linkStyles = {
    fontSize: '12px',
    fontWeight: 500,
    color: 'neutral.1500',
    paddingY: 2,
    paddingLeft: 7,
    borderRadius: '8px',
    _hover: {
      cursor: 'pointer',
      backgroundColor: hexToRGBA(brandColor, 0.1),
    },
  };

  return navLink.isAngular ? (
    <ChakraLink href={navLink.route} sx={linkStyles}>
      {navLink.name}
    </ChakraLink>
  ) : (
    <ChakraLink as={RouterLink} to={navLink.route} sx={linkStyles}>
      {navLink.name}
    </ChakraLink>
  );
}
